import React from 'react';
import { Tabs } from 'antd';
import DefaultDrawer from '../defaultDrawer/DefaultDrawer';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import useTranslation from '../../../../hooks/translation/useTranslation';
import Stepper from '../../stepper/Stepper';

function RegisterDrawer({
  handleAlreadyRegistered,
  setLegalFormStep,
  physicalFormStep,
  legalFormStep,
  registrationType,
  setRegistrationType,
  setPhysicalFormStep,
  items,
  handleClose,
}) {
  const { showRegisterModal } = useModal();
  const { width } = useWindowDimensions();
  const { trans } = useTranslation();

  return (
    <DefaultDrawer
      title={(
        <div className="flex items-center justify-between pr-10 xsm:pr-5">
          <Stepper steps={2} activeStep={registrationType === 'physical' ? physicalFormStep : legalFormStep} setActiveStep={registrationType === 'physical' ? setPhysicalFormStep : setLegalFormStep} />
        </div>
      )}
      placement="bottom"
      setShow={handleClose}
      show={showRegisterModal && width < 1024}
      className="gray-after auth-drawer media"
      style={{
        backgroundColor: '#f1f2f6',
      }}
    >
      <div className="flex flex-col gap-10">
        <div className="flex flex-col gap-4 items-start">
          <h3 className="m-0 text-base">
            {trans('already_registered')}
          </h3>
          <button onClick={handleAlreadyRegistered} type="button" className="bg-transparent border-0 cursor-pointer p-0">
            <h2 className="m-0 text-xl text-primary">{trans('authorization')}</h2>
          </button>
        </div>
        <h1 className="m-0 text-2xl">{trans('registration')}</h1>
        <Tabs className="register-tabs" items={items} activeKey={registrationType} onChange={(e) => setRegistrationType(e)} />
      </div>

    </DefaultDrawer>
  );
}

export default RegisterDrawer;
